{
    "ShowMore": "Afficher plus",
    "ShowLess": "Montrer moins",
    "NAME": "LanguageSnackbar"
}